import React, { useRef, useEffect } from "react";

const ScrollToHereOnMount = (): JSX.Element => {
  const elementRef = useRef();
  useEffect(() => elementRef.current.scrollIntoView(), []);
  return <div ref={elementRef} />;
};

export default ScrollToHereOnMount;
